import React from 'react';
import PropTypes from 'prop-types';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';

import { SubmitButton } from '../wallet-registration/components/modal-footer/primary-action-button/submit-button';
import { useWalletRegistrationFormContext } from '../wallet-registration/contexts/wallet-registration-form-context';

import { messages } from './messages';
import styles from './carrier-update-modal.module.less';

export const WalletUpdateModalFooter = ({ canProgress = false }) => {
  const { submittingRegistration } = useWalletRegistrationFormContext();

  return (
    <ModalFooter className={styles['modal-footer']}>
      <ModalFooterCancelButton disabled={submittingRegistration} />
      <SubmitButton buttonMessageDescriptor={messages.updateButton} disabled={!canProgress || submittingRegistration} isUpdate />
    </ModalFooter>
  );
};

WalletUpdateModalFooter.propTypes = {
  canProgress: PropTypes.bool,
};
